import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Nav from './components/Nav'
import Footer from './components/Footer'
import ChatWidget from './components/ChatWidget/ChatWidget'

// pages …
import Home from './pages/annonces'
import CommentCaMarche from './pages/comment-ca-marche'
import Partenaires from './pages/partenaires'
import AppMobile from './pages/app-mobile'
import Contact from './pages/contact'
import Bailleurs from './pages/bailleurs'
import AnnonceDetail from './pages/annonce-detail'
import Signup from './pages/signup'
import Login from './pages/login'
import AGB from './pages/agb'
import Datenschutz from './pages/datenschutz'
import Impressum from './pages/impressum'
import BailleursNew from './pages/bailleurs-new'
import AnnonceView from './pages/annonce-view'
import BailleursEdit from './pages/bailleurs-edit'
import ChatPage from "./pages/ChatPage";
import ChatStart from "./pages/ChatStart";
import ChatRedirect from "./pages/ChatRedirect";
import NotificationBell from "./components/NotificationBell";

export default function App(){
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <div className="absolute top-4 right-4 z-50">
          <NotificationBell />
      </div>
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/annonces" element={<Home />} />
          <Route path="/annonce/:id" element={<AnnonceDetail />} />
          <Route path="/annonce/:id" element={<AnnonceView />} />
          <Route path="/comment-ca-marche" element={<CommentCaMarche />} />
          <Route path="/partenaires" element={<Partenaires />} />
          <Route path="/app-mobile" element={<AppMobile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/bailleurs" element={<Bailleurs />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/bailleurs/nouveau" element={<BailleursNew />} />
          <Route path="/bailleurs/:id/edit" element={<BailleursEdit />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat/new" element={<ChatRedirect />} />
          <Route path="/chat/start" element={<ChatStart />} />
          <Route path="/chat/:conversationId" element={<ChatPage />} />
        </Routes>
      </div>

      <Footer />

      <ChatWidget />
    </div>
  )
}
